import { FlagsState, SetFlagOptions, SetFeatureFlagsOptions } from '@/store/flags/types';

export default {
    SET_FLAG(state:FlagsState, { flag, value }:SetFlagOptions) {
        state[flag] = value;
    },

    SET_LEGACY_QUESTIONS(state:FlagsState, value:boolean) {
        state.legacyQuestions = value;
    },

    SET_FEATURE_FLAGS(state:FlagsState, { flags }:SetFeatureFlagsOptions) {
        // Set each flag in the state (extract 'enabled' property if it's an object)
        Object.keys(flags).forEach((flag) => {
            const value = flags[flag];

            // Handle both formats:
            // 1. { "flag": true } - direct boolean
            // 2. { "flag": { "enabled": true } } - nested object with enabled property
            if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                // Check if it's an object with 'enabled' property
                if ('enabled' in value && typeof (value as { enabled: unknown }).enabled === 'boolean') {
                    state[flag] = (value as { enabled: boolean }).enabled;
                } else {
                    // Object but no 'enabled' property - treat as falsy
                    state[flag] = false;
                }
            } else if (typeof value === 'boolean') {
                state[flag] = value;
            } else {
                // Unexpected type - default to false
                state[flag] = false;
            }
        });

        // Mark that we've fetched feature flags
        state.featureFlagsFetched = true;
    },
};
